module.exports = __webpack_public_path__ + "media/hemorrhoid.d652075a.wav";